import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayAccountAlertIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      strokeWidth={strokeWidth}
      viewBox="0 0 24 24"
    >
      <path
        d="M10.49 13.64C14.18 13.64 17.19 10.64 17.19 6.94C17.19 3.24 14.18 0.25 10.49 0.25C6.79998 0.25 3.78998 3.25 3.78998 6.95C3.78998 10.65 6.78998 13.65 10.49 13.65V13.64ZM10.49 1.75C13.35 1.75 15.69 4.08 15.69 6.95C15.69 9.82 13.36 12.15 10.49 12.15C7.61998 12.15 5.28998 9.82 5.28998 6.95C5.28998 4.08 7.61998 1.75 10.49 1.75Z"
        fill={color}
      />
      <path
        d="M18.75 12.12C16.53 12.12 14.66 13.54 13.95 15.51C12.87 15.26 11.71 15.11 10.5 15.11C6.71003 15.11 3.36003 16.43 1.54003 18.64C0.770027 19.58 0.610027 20.84 1.13003 21.93C1.66003 23.05 2.77003 23.74 4.02003 23.74H16.98C18.1 23.74 19.1 23.18 19.68 22.27C22.06 21.83 23.88 19.75 23.88 17.24C23.88 14.41 21.58 12.12 18.76 12.12H18.75ZM16.98 22.25H4.02003C3.34003 22.25 2.77003 21.89 2.49003 21.3C2.22003 20.73 2.30003 20.09 2.70003 19.6C4.24003 17.73 7.15003 16.62 10.5 16.62C11.61 16.62 12.67 16.75 13.65 16.99C13.45 19.44 15.19 21.61 17.45 22.19C17.3 22.23 17.14 22.25 16.98 22.25ZM18.75 21.12C16.61 21.12 14.87 19.38 14.87 17.24C14.87 15.1 16.61 13.36 18.75 13.36C20.89 13.36 22.63 15.1 22.63 17.24C22.63 19.38 20.89 21.12 18.75 21.12Z"
        fill={color}
      />
      <path
        d="M19 19H18.5C18.3619 19 18.25 19.1119 18.25 19.25V19.75C18.25 19.8881 18.3619 20 18.5 20H19C19.1381 20 19.25 19.8881 19.25 19.75V19.25C19.25 19.1119 19.1381 19 19 19Z"
        fill={color}
      />
      <path
        d="M19 14.75H18.5C18.3619 14.75 18.25 14.8619 18.25 15V18C18.25 18.1381 18.3619 18.25 18.5 18.25H19C19.1381 18.25 19.25 18.1381 19.25 18V15C19.25 14.8619 19.1381 14.75 19 14.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayAccountAlertIcon.displayName = 'PayAccountAlertIcon';
